import { IconButton } from "@similarweb/ui-components";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { translate } from "app/filters/i18nFilter";
import { StyledAdditionalLabel } from "app/pages/sales-intelligence/modules/enrichment/components/FieldsDropdown/style";
import { NOT_SELECTED, SELECT_HINT } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";
import { StyledButtonContainer, StyledRightPart, StyledCountWrapper, StyledTitleWrapper, StyledIcon } from "./style";

type IconDropdownButton = {
    title: string;
    selectedNumber: number;
    allOptionsNumber: number;
    isOpen: boolean;
    isInfoVisible: boolean;
    onCloseClick(): void;
    onClick?(): void;
};

export const IconDropdownButton = ({
    title,
    selectedNumber,
    allOptionsNumber,
    isOpen,
    isInfoVisible,
    onClick,
    onCloseClick,
}: IconDropdownButton) => {
    const icon = isOpen ? "chev-down" : "chev-up";
    const countValue = `${selectedNumber}/${allOptionsNumber}`;

    const handleClick = () => {
        isOpen && onCloseClick();
    };

    return (
        <StyledButtonContainer
            isOpen={isOpen}
            onClick={onClick}
        >
            <StyledTitleWrapper>
                <div>{title}</div>
                {isInfoVisible ? (
                    <>
                        <StyledAdditionalLabel>{`- ${translate(NOT_SELECTED)}`}</StyledAdditionalLabel>

                        <PlainTooltip text={translate(SELECT_HINT)}>
                            <div>
                                <StyledIcon
                                    iconName="info"
                                    size="xs"
                                />
                            </div>
                        </PlainTooltip>
                    </>
                ) : null}
            </StyledTitleWrapper>
            <StyledRightPart>
                <StyledCountWrapper>{countValue}</StyledCountWrapper>
                <IconButton
                    onClick={handleClick}
                    type="flat"
                    iconName={icon}
                    iconSize="xs"
                />
            </StyledRightPart>
        </StyledButtonContainer>
    );
};
